const state = {
  lang: navigator.language === 'zh-CN' ? 'zh' : 'en',
  device: 'pc'
}

const mutations = {
  SET_LANG: (state, data) => {
    state.lang = data
  },
  SET_DEVICE: (state, data) => {
    state.device = data
  }
}

const actions = {
  setLang({ commit }, params) {
    commit('SET_LANG', params)
  },
  toggleDevice({ commit }, params) {
    commit('SET_DEVICE', params)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
